import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import Loader from "../../components/utils/Loader";

const ExamUnionRankers = () => {
    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();

    const [setLiteList, setSetLiteList] = useState([]);

    const [examOptions, setExamOptions] = useState([]);
    const [seriesOptions, setSeriesOptions] = useState([]);
    const [setOptions, setSetOptions] = useState([]);

    const [examFilter, setExamFilter] = useState("");
    const [seriesFilter, setSeriesFilter] = useState("");
    const [setFilter, setSetFilter] = useState("");

    const [rankers, setRankers] = useState([]);
    const [totalCandidates, setTotalCandidates] = useState(0);
    const [error, setError] = useState(false);

    // ================= FETCH PRACTICED SET LITE =================
    useEffect(() => {
        fetchPracticedSetLite();
    }, []);

    const fetchPracticedSetLite = async () => {
        try {
            const res = await fetchData({
                url: "/mypracticedsets/practicedsetlitebyuser",
                method: "post",
                headers: { Authorization: authState.token },
                data: { userId: authState.user?._id }
            });

            if (res?.practicedSetlist?.length) {
                const list = res.practicedSetlist;

                setSetLiteList(list);

                const exams = [...new Set(list.map(s => s.examTitle))];
                setExamOptions(exams);
            }

        } catch (err) {
            console.error(err);
        }
    };

    // ================= EXAM → SERIES =================
    const handleExamChange = (value) => {
        setExamFilter(value);
        setSeriesFilter("");
        setSetFilter("");
        setSetOptions([]);
        setRankers([]);

        const filteredSeries = setLiteList
            .filter(s => s.examTitle === value)
            .map(s => s.seriesTitle);

        setSeriesOptions([...new Set(filteredSeries)]);
    };

    // ================= SERIES → SET =================
    useEffect(() => {
        if (!seriesFilter || !examFilter) return;

        const filteredSets = setLiteList
            .filter(s =>
                s.examTitle === examFilter &&
                s.seriesTitle === seriesFilter
            )
            .map(s => ({
                setId: s.setId,
                setTitle: s.setTitle
            }));

        const uniqueSets = Array.from(
            new Map(filteredSets.map(s => [s.setId, s])).values()
        );

        setSetOptions(uniqueSets);

    }, [seriesFilter, examFilter, setLiteList]);

    // ================= FETCH TOP RANKERS =================
    const fetchTopRankers = async () => {
        setRankers([]);
        setError(false);

        try {
            const res = await fetchData({
                url: "/examunionranking/toprankers",
                method: "post",
                headers: { Authorization: authState.token },
                data: { setId: setFilter }
            });

            // ✅ IMPORTANT FIX
            if (!res || !res.rankers) {
                throw new Error("No rankers");
            }

            setRankers(res.rankers);
            setTotalCandidates(res.totalCandidates);

        } catch (err) {
            console.error("Top Rankers API failed");

            setError(true);
            setRankers(generateDummyRankers());
        }
    };

    // ================= DUMMY =================
    const generateDummyRankers = () => {
        return Array.from({ length: 10 }).map((_, i) => ({
            rank: i + 1,
            userCode: "EU" + Math.floor(Math.random() * 99999),
            score: Math.floor(Math.random() * 300)
        }));
    };

    return (
        <div className="min-h-screen bg-black text-white p-4">

            <h2 className="text-center text-xl font-bold text-yellow-300 mb-4">
                🏆 Top 10 Rankers
            </h2>

            {/* FILTERS */}
            <div className="space-y-2">

                <select
                    value={examFilter}
                    onChange={(e) => handleExamChange(e.target.value)}
                    className="w-full h-10 text-black rounded px-2"
                >
                    <option value="">Select Exam</option>
                    {examOptions.map(e => (
                        <option key={e} value={e}>{e}</option>
                    ))}
                </select>

                <select
                    value={seriesFilter}
                    onChange={(e) => setSeriesFilter(e.target.value)}
                    className="w-full h-10 text-black rounded px-2"
                >
                    <option value="">Select Series</option>
                    {seriesOptions.map(s => (
                        <option key={s} value={s}>{s}</option>
                    ))}
                </select>

                <select
                    value={setFilter}
                    onChange={(e) => setSetFilter(e.target.value)}
                    className="w-full h-10 text-black rounded px-2"
                >
                    <option value="">Select Set</option>
                    {setOptions.map(s => (
                        <option key={s.setId} value={s.setId}>
                            {s.setTitle}
                        </option>
                    ))}
                </select>

                <button
                    onClick={fetchTopRankers}
                    disabled={!setFilter}
                    className="w-48 py-2 bg-yellow-500 text-black font-bold rounded"
                >
                    Show Top 10 Rankers
                </button>
            </div>

            {loading && <Loader />}

            {/* RESULT */}
            {rankers.length > 0 && (
                <div className="mt-6 bg-gray-800 p-4 rounded">

                    {error && (
                        <p className="text-xs text-red-400 mb-2">
                            ⚠️ Showing demo leaderboard
                        </p>
                    )}

                    <p className="text-sm text-gray-300 mb-2">
                        Total Candidates: {totalCandidates}
                    </p>

                    <div className="space-y-2">
                        {rankers.map(r => (
                            <div
                                key={r.rank}
                                className="flex justify-between bg-black p-2 rounded"
                            >
                                <span>#{r.rank}</span>
                                <span>{r.userCode}</span>
                                <span>{r.userName}</span>
                                <span>{r.score}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ExamUnionRankers;